import React from 'react';
import {
  Backdrop, Box, Fade, IconButton, makeStyles, Modal,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

const useStyles = makeStyles(({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default ({ isOpen, onClose, data }) => {
  const classes = useStyles();
  const { imageUrl, urlToGo } = data || {};
  return (
    <Modal
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      className={classes.modal}
      closeAfterTransition
      onClose={onClose}
      open={isOpen}
    >
      <Fade in={isOpen}>
        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          width={{ xs: 3 / 4, sm: 3 / 5 }}
          position="relative"
          style={{
            outline: 'none',
          }}
        >
          <Box
            position="absolute"
            top={0}
            right={0}
            onClick={onClose}
          >
            <IconButton
              style={{ padding: 0 }}
              disableRipple
            >
              <HighlightOffIcon style={{ fontSize: 32 }} />
            </IconButton>
          </Box>
          <Link to={urlToGo}>
            <img src={imageUrl} alt="" width="100%" height="100%" />
          </Link>
          <Box color="white" fontWeight="bold">點擊空白處關閉活動資訊</Box>
        </Box>
      </Fade>
    </Modal>
  );
};
